import React from "react";
import { Switch } from "../Switch";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { setMarketing, setTerms } from "../../stores/credit/credit.reducer";
import { useCreditSelector } from "../../stores/product/product.store";

export const Terms = () => {
    const text = useCreditSelector((state: CreditState) => state.text);
    const selectedMonth = useCreditSelector((state: CreditState) => state.selectMonth);
    const terms = useCreditSelector((state: CreditState) => state.terms);
    const marketing = useCreditSelector((state: CreditState) => state.marketing);
    const dispatch = useCreditDispatch();

    const onChangeMarketing = () => {
        dispatch(setMarketing(!marketing));
    }

    const onChangeTerms = () => {
        dispatch(setTerms(!terms));
    }

    return (
        <>
            <div className="flex justify-between items-center mb-2">
                <label className="text-black text-sm"
                       htmlFor="advertising"
                       dangerouslySetInnerHTML={ { __html: `${ text.termsAdverting } ${ selectedMonth?.terms }` } }/>
                <Switch id="advertising" checked={ marketing } onChange={ onChangeMarketing }/>
            </div>
            <div className="mb-5 flex justify-between items-center">
                <label className="text-black text-sm"
                       htmlFor="terms"
                       dangerouslySetInnerHTML={ { __html: `${ text.terms } ${ selectedMonth?.terms }` } }/>
                <Switch id="terms" checked={ terms } onChange={ onChangeTerms }/>
            </div>
        </>
    )
}